import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useCustomerAuthStore } from '@/stores/customer-auth.store';
import { CUSTOMER_PORTAL_ROUTES } from '@/routes/customer-portal-routes';

/**
 * Mirrors PlatformProtectedRoute exactly, against the customer auth store —
 * plus (User Profile P2, S-11) the forced password change the staff
 * ProtectedRoute has always applied: a contact whose `mustChangePassword` is
 * set reaches nothing but the change-password page until they change it. The
 * flag is authoritative after boot because CustomerAuthInitializer re-reads
 * `/me` every time.
 */
export function CustomerProtectedRoute() {
  const isAuthenticated = useCustomerAuthStore((s) => s.isAuthenticated);
  const user = useCustomerAuthStore((s) => s.user);
  const location = useLocation();

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${CUSTOMER_PORTAL_ROUTES.LOGIN}?redirect=${redirect}`} replace />;
  }

  if (user?.mustChangePassword && location.pathname !== CUSTOMER_PORTAL_ROUTES.CHANGE_PASSWORD) {
    return <Navigate to={CUSTOMER_PORTAL_ROUTES.CHANGE_PASSWORD} replace />;
  }

  return <Outlet />;
}
